import { isChunkLoadError } from '@utils/chunkLoadError';
import { lazy } from 'react';

const RETRY_DELAY_MS = 1000;
const MAX_DELAY_MS = 5000;

const wait = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

const importWithRetry = (importer, attempt = 0) =>
  importer().catch((error) => {
    if (!isChunkLoadError(error)) {
      throw error;
    }

    const delay = Math.min(RETRY_DELAY_MS * (attempt + 1), MAX_DELAY_MS);
    return wait(delay).then(() => importWithRetry(importer, attempt + 1));
  });

const lazyWithRetry = (importer) => lazy(() => importWithRetry(importer));

export default lazyWithRetry;
